<template>
  <div>
    <!-- {{ userStore.roles }} -->
    <div v-if="AreIdsShown">
      Role Filter:
      <button
        type="button"
        size="sm"
        :class="modalTheme"
        @click="
          selectedRole = '';
          selectedLeftRole = [];
          selectedRightRole = '';
        "
        aria-label="Clear selected role filters"
        title="Clear selected role filters"
        style="margin-right: 8px"
      >
        &times;
      </button>
      <select v-model="selectedRole" :disabled="roleOptions.length === 0">
        <option value="">NONE</option>
        <option v-for="role in roleOptions" :key="`full-${role}`" :value="role">{{ role }}</option>
      </select>
      <select v-model="selectedLeftRole" :disabled="leftRoleOptions.length === 0" multiple style="height: 3em">
        <option value="">NONE</option>
        <option v-for="role in leftRoleOptions" :key="`left-${role}`" :value="role">{{ role }}</option>
      </select>
      <select v-model="selectedRightRole" :disabled="rightRoleOptions.length === 0" style="margin-left: 8px">
        <option value="">NONE</option>
        <option v-for="role in rightRoleOptions" :key="`right-${role}`" :value="role">{{ role }}</option>
      </select>
    </div>
    <!-- {{ userStore.roles[0]?.role }} -->
    <!-- FILTERED: {{ filteredRoles }} -->
    <!-- <div v-if="userStore.isAuthenticated" class="layout">
      <b-nav justified style="background: darkblue; padding: 3px; height: 25px; font-size: 10pt" :class="modalTheme">
        <b-nav-item active-class="worklists-active" to="/landing">Landing</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/emr">Physicians Console</b-nav-item>
        <b-nav-item to="/scheduler">Scheduler</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/Admin">Admin</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/PatientPortal">PatientPortal</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/Billing">Billing</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/NOC">NOC</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/announcements">Announcements</b-nav-item>
      </b-nav>

      <div class="tab-content" :class="modalTheme">
        <RouterView />
      </div>
    </div> -->
    <div v-if="userStore.isAuthenticated" class="layout">
      <!-- <h3>2B Console Nav </h3> -->
      <b-nav justified style="background: transparent; padding: 3px; height: 25px; font-size: 10pt" :class="modalTheme">
        <!-- <b-nav-item active-class="worklists-active" to="/landing">Landing</b-nav-item> -->
        <span hidden original style="background: darkred">
          <b-nav-item active-class="worklists-active" to="/emr">Physicians Console</b-nav-item>

          <b-nav-item v-if="filteredRoles.some((filteredRole) => hasExactRoleMatch(filteredRole?.role ?? filteredRole, 'Global_Admin'))" to="/scheduler">Scheduler</b-nav-item>
          <b-nav-item v-if="filteredRoles.some((filteredRole) => hasExactRoleMatch(filteredRole?.role ?? filteredRole, 'Global_Admin'))" to="/blank">Blank</b-nav-item>

          <b-nav-item v-if="filteredRoles.some((filteredRole) => hasExactRoleMatch(filteredRole?.role ?? filteredRole, '(ADMIN)'))" active-class="worklists-active" to="/Admin"> Admin </b-nav-item>

          <b-nav-item v-if="filteredRoles.some((filteredRole) => (filteredRole?.role ?? filteredRole) === '(EMRS)|Epic_User')" active-class="worklists-active" to="/PatientPortal"
            >PatientPortal</b-nav-item
          >
          <b-nav-item v-if="filteredRoles.some((filteredRole) => hasExactRoleMatch(filteredRole?.role ?? filteredRole, 'Coder'))" active-class="worklists-active" to="/Billing">Billing</b-nav-item>
          <b-nav-item v-if="filteredRoles.some((filteredRole) => hasExactRoleMatch(filteredRole?.role ?? filteredRole, 'Coder'))" active-class="worklists-active" to="/NOC">NOC</b-nav-item>

          <b-nav-item
            v-if="filteredRoles.some((filteredRole) => hasExactRoleMatch(filteredRole?.role ?? filteredRole, '(HCCW)') || hasExactRoleMatch(filteredRole?.role ?? filteredRole, '(ADMIN)'))"
            active-class="worklists-active"
            to="/announcements"
            >Announcements</b-nav-item
          >
        </span>

        <!-- *NEW -->
        <!-- <b-nav-item active-class="worklists-active" to="/landing">Landing</b-nav-item> -->
        <b-nav-item active-class="worklists-active" to="/emr">Chart</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/scheduler">Scheduler</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/Billing">Billing</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/NOC">NOC</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/PatientPortal">Patient Portal</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/practiceMgnt">Practice Mgt</b-nav-item>

        <b-nav-item active-class="worklists-active" to="/Admin">ADMIN</b-nav-item>
        <!-- <b-nav-item v-if="filteredRoles.some((filteredRole) => hasExactRoleMatch(filteredRole?.role ?? filteredRole, '(ADMIN)'))" active-class="worklists-active" to="/Admin"> Admin </b-nav-item> -->

        <b-nav-item active-class="worklists-active" to="/analytics">Analytics</b-nav-item>
        <b-nav-item active-class="worklists-active" to="/announcements">Announcements</b-nav-item>
      </b-nav>

      <div class="tab-content" :class="modalTheme">
        <RouterView />
      </div>
    </div>
    <div v-else>
      <Landing />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";

// & ROUTER
import { RouterLink, RouterView, useRoute, useRouter } from "vue-router";

import config from "devextreme/core/config";
import { licenseKey } from "./devextreme-license";

config({ licenseKey });

import { getToken } from "@/config/authService";

// * STORE
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import themes, { init } from "devextreme/ui/themes";
init(); // Initialize themes if needed
const savedTheme = localStorage.getItem("dx-theme") || "generic.light.white";

// & COMPOSIBLEs
import { initializeTheme } from "@/use/themeUtils.js";
initializeTheme();

import UserProfile from "@/modules/User/UserProfile.vue";

import PhysiciansConsole from "./PhysiciansConsole.vue";
import Admin from "./Admin.vue";
import PatientPortal from "./PatientPortal.vue";
import Billing from "./Billing.vue";
import NOC from "./NOC.vue";
import Landing from "./views/Landing.vue";

const AreIdsShown = ref(false);
const selectedRole = ref("");
const selectedLeftRole = ref([]);
const selectedRightRole = ref("");
const syncingFromFullRole = ref(false);
const syncingFromPairFilters = ref(false);

const parseRolePair = (value) => {
  const [left = "", right = ""] = String(value ?? "")
    .split("|")
    .map((token) => token.trim());

  return { left, right };
};

const hasExactRoleMatch = (value, target) => {
  const roleTokens = String(value ?? "")
    .split("|")
    .map((token) => token.trim())
    .filter(Boolean);

  return roleTokens.includes(String(target ?? "").trim());
};

const modalTheme = computed(() => userStore.bModalTheme);
const roleOptions = computed(() => {
  const roles = Array.isArray(userStore.masterRoles) ? userStore.masterRoles : [];
  return [...new Set(roles.map((r) => r?.role ?? r).filter(Boolean))];
});

const leftRoleOptions = computed(() => {
  const roles = Array.isArray(userStore.masterRoles) ? userStore.masterRoles : [];
  return [...new Set(roles.map((r) => parseRolePair(r?.role ?? r).left).filter(Boolean))];
});

const rightRoleOptions = computed(() => {
  const roles = Array.isArray(userStore.masterRoles) ? userStore.masterRoles : [];
  return [...new Set(roles.map((r) => parseRolePair(r?.role ?? r).right).filter(Boolean))];
});

const filteredRoles = computed(() => {
  const roles = Array.isArray(userStore.masterRoles) ? userStore.masterRoles : [];
  const selectedFullRole = selectedRole.value.trim();
  const selectedLeftArray = Array.isArray(selectedLeftRole.value) ? selectedLeftRole.value : [];
  const selectedRight = selectedRightRole.value.trim();

  // If no filters selected, return empty array
  if (!selectedFullRole && selectedLeftArray.length === 0 && !selectedRight) {
    return [];
  }

  if (selectedFullRole) {
    return roles.filter((role) => (role?.role ?? role) === selectedFullRole);
  }

  return roles.filter((role) => {
    const { left, right } = parseRolePair(role?.role ?? role);
    const leftMatches = selectedLeftArray.length === 0 || selectedLeftArray.includes(left);
    const rightMatches = !selectedRight || right === selectedRight;

    return leftMatches && rightMatches;
  });
});

watch(selectedRole, (newRole) => {
  if (syncingFromPairFilters.value) {
    syncingFromPairFilters.value = false;
    return;
  }

  syncingFromFullRole.value = true;
  const { left, right } = parseRolePair(newRole);
  selectedLeftRole.value = left ? [left] : [];
  selectedRightRole.value = right;
});

watch([selectedLeftRole, selectedRightRole], ([left, right]) => {
  if (syncingFromFullRole.value) {
    syncingFromFullRole.value = false;
    return;
  }

  syncingFromPairFilters.value = true;

  if ((!Array.isArray(left) || left.length === 0) && !right) {
    selectedRole.value = "";
    return;
  }

  if (Array.isArray(left) && left.length === 1 && right) {
    const matchedRole = roleOptions.value.find((role) => {
      const pair = parseRolePair(role);
      return pair.left === left[0] && pair.right === right;
    });

    selectedRole.value = matchedRole ?? "";
  } else {
    selectedRole.value = "";
  }
});

onMounted(async () => {
  console.log("onMounted() :      CONSOLE APP  >>>>");

  // console.log("  CONSOLE       themes ccheck        *");
  // console.log(themes.current());
  try {
    // Attempt silent login on component mount
    // console.log(" APP mount:  getToken()  REQUIRED to cycle past LANDING >>>>>>");
    const token = await getToken();
    if (token) {
      // console.log(" >>>>>>>>>>>>>>>>>>>>>>>                                                        [TheWelcome.vue] Silent login successful, token:   FOUND");
      // // console.log(" >>>>>>>>>>>>>>>>>>>>>>>                                                        [TheWelcome.vue] Silent login successful, token:", token);
      //await getUserData(); // Only call if authenticated
    }
  } catch (e) {
    // console.log("                    Silent login failed:", e);
    // Optionally, handle errors or show a message
  }
});
</script>
<style lang="scss">
// @import "@/assets/css/main.scss";
</style>
